<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Project Orders Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/project-consumption-reports">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row dense>
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.StartDate"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.EndDate"
                    label="To"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                autocomplete="off"
                dense
                outlined
                v-model="record.ProjectId"
                :items="projects"
                label="Project"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-btn
                class="right"
                color="primary"
                :loading="loader"
                @click="getReport"
              >generate Report</v-btn>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-text-field dense label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-divider></v-divider>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              xs="12"
              md="4"
              class="subtitle-2 text--primary section-bg mb-2 style-16"
            >
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>
                        <span class="style-18 custom-primary">Total Orders Value</span>
                      </td>
                      <td>
                        <span class="style-18 custom-primary">{{ totalSales | currency }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-data-table
                :mobile-breakpoint="0"
                :items-per-page="pageItems"
                :headers="headers"
                :items="dailySales"
                :search="search"
              >
                <!-- template -->
                <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.TotalPaid="{ item }">
                  {{
                  item.TotalPaid | currency
                  }}
                </template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.Balance="{ item }">
                  {{
                  item.Balance | currency
                  }}
                </template>
                <!-- end -->

                <!-- template -->
                <template v-slot:item.Date="{ item }">
                  {{
                  item.Date | date
                  }}
                </template>
                <!-- end -->

                <!-- action template -->
                <template v-slot:item.DocNum="{ item }">
                  <v-btn color="accent" text :to="`/project-order-details/${item.id}`">
                    {{ item.DocNum }}
                    <v-icon right>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

          <v-row>
            <v-divider></v-divider>
          </v-row>

          <v-row v-show="returnsData.length > 0">
            <v-col cols="12">
              <h3 style="color: red">Cancelled Sales</h3>
            </v-col>

            <v-col cols="12" style="margin-top: -20px">
              <v-data-table
                :mobile-breakpoint="0"
                :search="search"
                :headers="returnHeaders"
                :items="returnsData"
              >
                <!-- DocNum template -->
                <template v-slot:item.odln="{ item }">
                  <v-btn color="red" text @click="showProducts(item.OdlnId)">
                    <span>{{ item.odln.DocNum }}</span>
                  </v-btn>
                </template>
                <!-- end -->
                <!-- DocTotal template -->
                <template v-slot:item.ocrd="{ item }">
                  <span style="color: red">{{ item.ocrd.Name }}</span>
                </template>
                <!-- end -->
                <!-- DocTotal template -->
                <template v-slot:item.DocTotal="{ item }">
                  <span style="color: red">
                    {{
                    item.DocTotal.toLocaleString()
                    }}
                  </span>
                </template>
                <!-- end -->
                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn color="red" text @click="showProducts(item.OdlnId)" icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>

          <!-- products modal -->
          <v-dialog v-model="productsDialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Sold Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="productsDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row dense id="po">
                    <v-col cols="12" xs="12" md="3">
                      <span>Customer: {{ record.ocrd && record.ocrd.Name }}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="3">Receipt No: {{ record.DocNum }}</v-col>

                    <v-col cols="12" xs="12" md="3">Date: {{ record.DocDate }}</v-col>

                    <v-col cols="12" id="docForm">
                      <v-data-table
                        light
                        :items-per-page="pageItems"
                        :headers="soldHeaders"
                        :items="soldItems"
                        item-key="id"
                        hide-default-footer
                        disable-sort
                        :mobile-breakpoint="zeroValue"
                      >
                        <template v-slot:item.Name="{ item }">
                          {{
                          item.Name
                          }}
                        </template>

                        <template v-slot:item.ref1="{ item }">
                          {{
                          item.ref1
                          }}
                        </template>

                        <template v-slot:item.Quantity="{ item }">
                          {{
                          item.Quantity
                          }}
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span v-if="item.Price">
                            {{
                            item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.DiscSum="{ item }">
                          {{
                          item.DiscSum
                          }}
                        </template>

                        <template v-slot:item.DisplayTotal="{ item }">
                          {{
                          item.DisplayTotal
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal -->

          <!-- Cancelled products dialog -->
          <v-dialog v-model="cancelledDialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Cancelled/Returned Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="cancelledDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" xs="12">
                      <h4 style="color: red">Cancelled/Returned products</h4>
                      <v-data-table
                        light
                        :mobile-breakpoint="0"
                        :items-per-page="100"
                        :headers="cancelledHeaders"
                        :items="cancelledData"
                        item-key="id"
                        hide-default-footer
                      >
                        <template v-slot:item.product="{ item }">
                          <span style="color: red">
                            {{
                            item.product.Name
                            }}
                          </span>
                        </template>

                        <template v-slot:item.Quantity="{ item }">
                          <span style="color: red">{{ item.Quantity }}</span>
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span style="color: red">
                            {{
                            item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.LineTotal="{ item }">
                          <span style="color: red">
                            {{
                            item.LineTotal.toLocaleString()
                            }}
                          </span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of cancelled products modal-->
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
import "export-json-excel";
export default {
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      record: {},
      productsDialog: false,
      salesLoader: false,
      soldItems: [],
      pageItems: 100,
      zeroValue: 0,
      menu1: false,
      menu2: false,
      loader: false,
      search: null,
      projects: [],
      reportData: {},
      TotalReturns: null,
      TotalServices: 0,
      returnsData: [],
      reportDataAllSales: [],
      cancelledDialog: false,
      cancelledData: [],
      drivers: [],
      dailySales: [],
      totalSales: 0,
      totalPayments: 0,
      creditSales: 0,
      cancelledHeaders: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      soldHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" }
      ],
      headers: [
        { text: "Doc Num.", value: "DocNum" },
        { text: "Project", value: "ProjectName" },
        { text: "Total", value: "DocTotal" },
        { text: "Ordered By", value: "SoldBy" },
        { text: "Date", value: "Date" }
      ],
      returnHeaders: [
        { text: "Invoice No.", value: "odln" },
        { text: "Customer", value: "ocrd" },
        { text: "Return Value", value: "DocTotal" },
        { text: "Date", value: "DocDate" },
        { text: "Date", value: "action" }
      ],
      fields: [
        {
          title: "Invoice#",
          name: "DocNum"
        },
        {
          title: "Total",
          name: "DocTotal"
        },
        {
          title: "Amount Paid",
          name: "PaidSum"
        },
        {
          title: "Balance",
          name: "Balance"
        },
        {
          title: "Date",
          type: " Date ",
          format: "YYYY/MM/DD",
          name: "DocDate"
        }
      ]
    };
  },
  methods: {
    openProductsModal(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.record = {};
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.soldItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    showProducts(OdlnId) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/cancelled-sale-products/${OdlnId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.cancelledData = res.ResponseData;
            self.$store.commit("loader", false);
            self.cancelledDialog = true;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getReport() {
      let data = this.record;
      const self = this;
      const url = `/daily-project-orders-report`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
            console.log(res, " p res");
          if (res.ResultCode == 1200) {
            self.dailySales = res.ResponseData.sales;
            self.totalSales = res.ResponseData.totalSales;
            this.totalPayments = res.ResponseData.totalPayments;
            this.creditSales = res.ResponseData.creditSales;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() {},
    getProjects() {
      const self = this;
      var url = `/store-projects/${self.activeStore}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.projects = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    exportToExcel() {}
  },
  created() {
    this.getProjects();
  }
};
</script>
  
  <style lang="scss" scoped>
</style>